import { styled } from '@mui/material/styles'
import { Button } from 'src/Components/Button'

export const StyledActionButton = styled(Button)`
  padding: 10px;
  width: 100%;
  font-size: 15px;
`
